import {
    ALL_PRODUCT_FAIL,
    ALL_PRODUCT_REQUEST,
    ALL_PRODUCT_SUCCESS, 
    PRODUCT_DETAILS_REQUEST,
    PRODUCT_DETAILS_SUCCESS,
    PRODUCT_DETAILS_FAIL,
    CLEAR_ERRORS
} from "../constants/productConstant"

const initialState = {
    products: [],
    product: {},
    productsCount: 0, 
    length: 0,
}

export const productReducer = (state = initialState, action) => {

    switch (action.type) {
        case ALL_PRODUCT_REQUEST:
            
            return {
                ...state,
                loading: true,
            }
        
        case ALL_PRODUCT_SUCCESS:
        
            return {
                ...state,
                loading: false,
                products: state.products.concat(action.payload.products),
                productsCount: action.payload.productsCount
            }

        case ALL_PRODUCT_FAIL:
    
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        
        case PRODUCT_DETAILS_REQUEST:
    
            return {
                ...state,
                loading: true,
            }
        
        case PRODUCT_DETAILS_SUCCESS:
        
            return {
                ...state,
                loading: false,
                product: action.payload,
            }

        case PRODUCT_DETAILS_FAIL:
    
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        case CLEAR_ERRORS:
    
            return {
                ...state,
                error: null
            }
    
        default:
            return state
    }

}
